module.exports = __webpack_public_path__ + "static/img/kjdy04.d41743e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doubleQianNiu/kjdy04.jpg
// module id = 1417
// module chunks = 0